package org.hs_soft.runmynesto.pages.components.dialog.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

@Composable
fun DialogTitle(
    modifier: Modifier=Modifier,
    title:String,
    leftRightPadding: CSSSizeValue<CSSUnit.px> =Dimen.extraLargePadding,
    showSeparator:Boolean=true,
    showCloseIcon:Boolean=false,
    fontWeight: FontWeight=FontWeight.Medium,
    color:CSSColorValue=Theme.TextPrimary.rgb,
    fontSize: CSSSizeValue<CSSUnit.px> =FontSizes.semiExtraLargeFontSize,
    onCloseClick:()->Unit={},
)
{
    Column(
        modifier = modifier
            .height(Dimen.dialogTitleHeight)
            .fillMaxWidth(),
        verticalArrangement = Arrangement.Center,

    )
    {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .padding(
                    left =leftRightPadding,
                    right = if (showCloseIcon) Dimen.largePadding else
                        leftRightPadding
                )
                .fillMaxWidth(),
        )
        {
            SpanText(
                text =title,
                modifier = Modifier
                    .align(Alignment.CenterStart)
                    .width(Dimen.selectRectPhoneWidth)
                    .cursor(Cursor.Pointer)
                    .textAlign(TextAlign.Start)
                    .fontSize(fontSize)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(fontWeight)
                    .color(color)
            )


            if (showCloseIcon){
                CircleIcon(
                    modifier = Modifier
                        .align(Alignment.CenterEnd),
                    size = Dimen.semiLargeIconSize2,
                    img = Res.PathIcon.largeClose,
                    borderColor = Theme.Transparent.rgb,
                    onIconClick = {
                        onCloseClick()
                    },
                )

            }



        }


        if (showSeparator){
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(Dimen.smallThickness)
                    .backgroundColor(Theme.Divider.rgb)
            )
        }

    }
}